import { useSelector } from 'react-redux';

import { RootState } from 'redux/store';
import { useGetUserQuery } from 'services/api/user.api';
import { User } from 'services/types/user';

const useCurrentUser = (): User | null => {
  const persistedUserToken = useSelector<RootState, RootState['user']['accessToken']>(
    (state) => state.user?.accessToken || ''
  );
  const { data: updatedUser } = useGetUserQuery(null, {
    skip: !persistedUserToken,
  });
  const persistedUser = useSelector<RootState, RootState['user']>((state) => state.user);

  return updatedUser
    ? {
        ...updatedUser,
        accessToken: persistedUserToken,
      }
    : persistedUser;
};

export default useCurrentUser;
